/**
 * The Vector ActOS mark.
 *
 * Downscaled from `a-act-logo.png` at the repo root — an export of the source
 * artwork made outside this repo, because the SVG does not survive a browser
 * intact: its "T" is an Inkscape `flowRoot`, an SVG 1.2 element nothing on the
 * web renders, and its "C" is an open arc with a fill and no stroke, so it
 * paints as a solid bean. The PNG is the artwork as it is meant to look.
 *
 * 304×240 is set by the LARGEST use, not the smallest: the sign-in card shows
 * it at 64px, which needs 192px on a 3× display. The 36px topbar use is then
 * covered many times over. It ships as a hashed file rather than inlined —
 * at 31 KiB, base64 in the bundle costs more (base64 inflates, and an
 * already-compressed PNG barely gzips) than the one cached request it saves.
 *
 * One size serves both places because a second asset is a second thing to
 * regenerate whenever the artwork changes, and the topbar cost of the larger
 * file is zero once it is cached.
 */

import markUrl from './assets/brand-mark.png';

export function BrandMark({ title }: { title?: string }) {
  return (
    <img
      className="brand-mark"
      src={markUrl}
      // Decorative by default: the wordmark next to it already says the name,
      // so a second announcement is noise to a screen reader.
      alt={title ?? ''}
      width={304}
      height={240}
      draggable={false}
    />
  );
}
